import { useGetMicropaymentMicropaymentsIdGet } from "@/api-v3";

import { normalizeMicropayment } from "../helpers/normalize-claim";

import { PaymentFetchView } from "./payment-fetch-view";
import { useActionableState } from "./use-actionable-state";

interface MicropaymentFetcherProps {
  id: string;
}

export const MicropaymentFetcher = ({ id }: MicropaymentFetcherProps) => {
  const { data, isLoading, error } = useGetMicropaymentMicropaymentsIdGet(id);
  const actions = useActionableState("micropayment", id);

  return (
    <PaymentFetchView
      isLoading={isLoading}
      error={error}
      view={data ? normalizeMicropayment(data) : null}
      actions={actions}
    />
  );
};
